import { EarningsPeriod } from '@api/api/earnings';
import { EarningsInsight } from '@api/api/earnings-insights';
import { getDefaultActiveReportingPeriod } from '@terminal/widgets/earnings/components/reporting-dates/utils';

export type EarningsInsightsByEntity = {
  latestEarningsData?: EarningsPeriod;
  earningsInsight?: EarningsInsight;
  exchange: string;
  isPreview: boolean;
};

type EarningsByTagEntry = {
  entityTag: string;
  earnings: EarningsPeriod[];
  exchange: string;
};

type DefaultPeriodByEntityTag = {
  latestEarningsData?: EarningsPeriod;
  exchange: string;
};

export const getDefaultPeriodsByEntityTag = (
  earningsByTag: EarningsByTagEntry[]
) => {
  const map = new Map<string, DefaultPeriodByEntityTag>();

  for (const { entityTag, earnings, exchange } of earningsByTag) {
    map.set(entityTag, {
      latestEarningsData:
        earnings.length > 0
          ? getDefaultActiveReportingPeriod(earnings)
          : undefined,
      exchange,
    });
  }

  return map;
};

export const getEarningsInsightsByEntityTag = (
  defaultPeriodsByEntityTag: Map<string, DefaultPeriodByEntityTag>,
  earningsInsightByEarningsId: Map<string, EarningsInsight>
) => {
  const map = new Map<string, EarningsInsightsByEntity>();

  defaultPeriodsByEntityTag.forEach(
    ({ latestEarningsData, exchange }, entityTag) => {
      const earningsInsight = latestEarningsData
        ? earningsInsightByEarningsId.get(latestEarningsData.id)
        : undefined;

      map.set(entityTag, {
        latestEarningsData,
        earningsInsight,
        exchange,
        isPreview:
          earningsInsight?.type === 'preview' ||
          (!!latestEarningsData && !latestEarningsData.reported),
      });
    }
  );

  return map;
};
